import Menu from 'components/molecules/menu_v2/menu_v2';
import { animateCSS } from 'js/tools';

const CLASS_FAVORITE_BUTTON_DISABLED = 'site-header__favorite--disabled';

const SELECTOR_MENU = '[data-component="menu"]';
const SELECTOR_MENU_BAR = '[data-component="menu-bar"]';
const SELECTOR_MENU_BUTTON = '[data-component="menu-button"]';

export default context => {
    const refs = {
        container: context.querySelector('.site-header__container'),
        favoriteButton: context.querySelector('.site-header__favorite'),
        favoriteCount: context.querySelector('.site-header__favorite-count')
    };

    if (!refs.favoriteButton) {
        return;
    }

    initMenu();

    window.addEventListener('favoritesUpdated', onFavoritesUpdated);

    toggleFavoriteButton(refs.favoriteButton, !isFavoriteButtonDisabled(refs.favoriteButton));

    function initMenu() {
        new Menu({
            menuNode: document.querySelector(SELECTOR_MENU),
            menuBarNode: document.querySelector(SELECTOR_MENU_BAR),
            menuButtonNode: document.querySelector(SELECTOR_MENU_BUTTON)
        });
    }

    function onFavoritesUpdated(e) {
        const { count } = e.detail;

        refs.favoriteButton.classList.toggle(CLASS_FAVORITE_BUTTON_DISABLED, count === 0);

        animateCSS({
            node: refs.favoriteButton,
            animationName: 'heartBeat'
        });

        refs.favoriteCount.innerHTML = e.detail.count;
    }

    const mutationObserver = new MutationObserver(([mutation]) => {
        toggleFavoriteButton(mutation.target, !isFavoriteButtonDisabled(mutation.target));
    });

    mutationObserver.observe(refs.favoriteButton, {
        attributes: true,
        attributeFilter: ['class']
    });

    function toggleFavoriteButton(favoriteButton, toggle) {
        if (toggle) {
            favoriteButton.removeEventListener('click', disableFavoriteButton);
        } else {
            favoriteButton.addEventListener('click', disableFavoriteButton);
        }
    }

    function isFavoriteButtonDisabled(favoriteButton) {
        return favoriteButton.classList.contains(CLASS_FAVORITE_BUTTON_DISABLED);
    }

    function disableFavoriteButton(e) {
        e.preventDefault();
    }
};
